import { Toast } from 'common/ToastMessage'
import Styles from 'screens/ProseEdit/components/RateGenerationToast/RateGenerationToast.module.scss'
import { FileQuestion2 } from 'blaze-ui/icons/24'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ThumbDown, ThumbUp } from 'blaze-ui/icons'
import { FeedbackToastProps } from './Types'

export const FeedbackToast = ({ onRate, onClose, theme = 'light', variant = 'rating' }: FeedbackToastProps) => (
  <Toast.Root variant={variant} theme={theme}>
    <Toast.Description clamp>
      <div className={Styles.description}>
        <FileQuestion2 size={20} />
        Do you like the result?
      </div>
    </Toast.Description>
    <Toast.Action>
      <div className={Styles.buttonsContainer}>
        <IconButton
          aria-label="Thumb down"
          onPress={() => {
            onRate('downvote')
          }}
          icon={() => <ThumbDown size={16} />}
          variant="tertiary"
          size="sm"
        />
        <IconButton
          aria-label="Thumb up"
          onPress={() => {
            onRate('upvote')
          }}
          icon={() => <ThumbUp size={16} />}
          variant="tertiary"
          size="sm"
        />
        <IconButton size="sm" variant="tertiary" onPress={onClose}>
          Close
        </IconButton>
      </div>
    </Toast.Action>
  </Toast.Root>
)
